import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=a3985fd2&scoped=true"
import script from "./DashboardMenu.vue?vue&type=script&lang=js"
export * from "./DashboardMenu.vue?vue&type=script&lang=js"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=a3985fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3985fd2",
  null
  
)

export default component.exports